import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { ROUTE_AUTHENTICATION } from "../../routes";

const PrivateRoute = ({ component: Component, userRole, noRole, ...rest }) => {
  const user = useSelector((state) => state.userDetail);
  const location = useLocation();
  const redirectPath =
    user.userRole !== userRole
      ? location.pathname.replace(userRole, user.userRole)
      : ROUTE_AUTHENTICATION;

  return (
    <Route
      {...rest}
      render={(props) =>
        user.isLogin ? (
          <>
            {noRole ? (
              <Component {...props} />
            ) : (
              <>
                {user.userRole === userRole ? (
                  <Component {...props} />
                ) : (
                  <Redirect to={redirectPath} />
                )}
              </>
            )}
          </>
        ) : (
          //
          <Redirect to={ROUTE_AUTHENTICATION} />
        )
      }
    />
  );
};

export default PrivateRoute;
